<template>
  <div class="container p-0 prescription-care-print">
    <b-overlay :show="loading" opacity="0.99">
      <div
        v-if="!certificate"
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-end content-btn-print"
      >
        <v-btn class="btn-print" @click="print"
          ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
        >
      </div>

      <table class="bg-white">
        <thead>
          <tr>
            <td>
              <div class="header-space">
                <div class="row">
                  <div
                    class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 d-flex align-items-center pt-0 pb-0"
                  >
                    <img
                      v-if="rest_home_logo_url"
                      class="rest_home_logo_url"
                      :src="rest_home_logo_url"
                    />

                    <h6 class="text-uppercase" v-if="!rest_home_logo_url">
                      {{ rest_home_name }}
                    </h6>
                  </div>

                  <div
                    class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 d-flex align-items-center pt-0 pb-0"
                  >
                    <img
                      v-if="group_prescription_care.resident_photo_url"
                      class="resident_photo_url"
                      :src="group_prescription_care.resident_photo_url"
                    />

                    <img
                      v-if="!group_prescription_care.resident_photo_url"
                      class="resident_photo_url"
                      :src="require('../../../assets/user.png')"
                    />

                    <ResidentDataPrintDefault
                      :resident_id="group_prescription_care.resident_id"
                    />
                  </div>

                  <div
                    class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 d-flex align-items-center justify-content-end pt-0 pb-0"
                  >
                    <div>
                      <img class="logo" :src="logo" width="180" />
                      <h6
                        v-if="group_prescription_care.finish_date"
                        class="pt-5 worksansr upper-text text-thirteen text-right"
                      >
                        Data:
                        {{
                          formatDate(group_prescription_care.finish_date, false)
                        }}
                      </h6>
                      <h6 class="worksansr upper-text"></h6>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <div class="content">
                <hr class="mt-0 mb-1" />
                <h6 class="mb-0 upper-text text-center">
                  Cuidados - Prescrição de cuidado -
                  <span class="color-blue">{{
                    formatDate(group_prescription_care.start_date, false)
                  }}</span>
                  até
                  <span class="color-blue">{{
                    formatDate(group_prescription_care.end_date, false)
                  }}</span>
                </h6>
                <h6
                  class="legends worksansr text-center"
                  v-if="
                    group_prescription_care.group_prescription_care_has_general_information
                  "
                >
                  <p class="m-0">INFORMAÇÕES GERAIS</p>

                  <span
                    v-for="information in group_prescription_care.group_prescription_care_has_general_information"
                    :key="information.id"
                  >
                    {{ information.description }};
                  </span>
                </h6>

                <hr class="mt-1 mb-0" />
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0"
                  style="page-break-inside: avoid !important"
                  v-for="(
                    item, key_care
                  ) in group_prescription_care.prescription_cares"
                  :key="key_care"
                >
                  <div class="row" style="page-break-inside: avoid !important">
                    <div
                      class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-1 pb-1 care d-flex align-items-center"
                    >
                      <div class="name">
                        <h6 class="mb-0 text-fourteen">
                          {{ item.care_name }}
                        </h6>

                        <h6
                          class="color-deleted mb-0 text-thirteen check-text-center"
                          v-if="item.prescription_care_status == 'EXCLUIDO'"
                        >
                          CUIDADO EXCLUIDO NO DIA
                          {{ formatDate(item.updated_at, false) }}.

                          <br />

                          <span>
                            NÃO IRÁ APARECER NA PRESCRIÇÃO A PARTIR DO DIA
                            {{ formatDate(item.end, false) }}!</span
                          >
                        </h6>

                        <h6
                          class="color-edit mb-0 text-thirteen check-text-center"
                          v-if="item.edited == 1"
                        >
                          CUIDADO EDITADO NO DIA
                          {{ formatDate(item.edited_date, false) }}.

                          <br />

                          <span class="color-deleted">
                            NÃO IRÁ APARECER NA PRESCRIÇÃO A PARTIR DO DIA
                            {{ formatDate(item.end, false) }}!
                          </span>
                        </h6>

                        <h6
                          class="upper-text mb-0 worksansr text-thirteen"
                          v-if="item.init"
                        >
                          Cuidado inicia:
                          {{ formatDate(item.init, false) }}
                        </h6>

                        <h6
                          class="upper-text mb-0 worksansr text-thirteen"
                          v-if="
                            item.prescription_care_status == 'EXCLUIDO' &&
                            item.end_care
                          "
                        >
                          Cuidado termina:
                          {{ formatDate(item.end_care, false) }}
                        </h6>

                        <h6
                          class="upper-text mb-0 worksansr text-thirteen"
                          v-if="item.edited == 1 && item.end_care"
                        >
                          Cuidado termina:
                          {{ formatDate(item.end_care, false) }}
                        </h6>

                        <h6
                          class="upper-text mb-0 mt-1 worksansr text-thirteen"
                        >
                          Cadastrado: {{ formatDate(item.created_at, false) }}
                        </h6>

                        <h6 class="upper-text mb-0 worksansr text-thirteen">
                          Última alteração:
                          {{ formatDate(item.updated_at, false) }}
                        </h6>
                      </div>
                    </div>

                    <div
                      class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 pt-1 pb-1 d-flex align-items-center"
                    >
                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex p-0"
                        >
                          <h6
                            v-if="item.frequency == 'SEMANAL'"
                            class="legends worksansr"
                          >
                            {{ item.dom && "DOM" }} - {{ item.seg && "SEG" }}
                            {{ item.ter && "TER" }} - {{ item.qua && "QUA" }}
                            {{ item.qui && "QUI" }} - {{ item.sex && "SEX" }}
                            {{ item.sab && "SAB" }} /
                          </h6>

                          <h6
                            v-if="
                              item.frequency != 'EVENTUAL' &&
                              item.care_amount_of_times_name
                            "
                            class="legends worksansr ml-1"
                          >
                            {{ item.care_amount_of_times_name }}
                          </h6>
                        </div>
                      </div>
                    </div>

                    <div
                      class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 pt-1 pb-1 d-flex flex-column align-items-center"
                    >
                      Horário(s)
                      <p
                        class="m-0 worksansr"
                        v-for="(time, key_time) in item.prescription_care_time"
                        :key="`${time.id}-${key_time}`"
                      >
                        {{
                          time.time
                            ? String(time.time).substring(
                                0,
                                String(time.time).length - 3
                              )
                            : "Não informado"
                        }}
                      </p>
                    </div>

                    <div
                      v-if="!certificate"
                      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
                    >
                      <History
                        title="MOVIMENTAÇÕES DO CUIDADO"
                        entity_id_disabled
                        user_id_disabled
                        :entity_id="item.id"
                        table="prescription_care"
                        :toggle="true"
                      />
                    </div>
                  </div>

                  <hr class="mb-0 mt-0 border-black" />
                </div>

                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0 pb-5"
                  style="page-break-inside: avoid !important"
                >
                  <div class="pb-5" v-if="!certificate">
                    <History
                      title="MOVIMENTAÇÕES DA PRESCRIÇÃO"
                      entity_id_disabled
                      user_id_disabled
                      :entity_id="group_prescription_care.id"
                      table="group_prescription_care"
                      :toggle="true"
                    />
                  </div>

                  <div
                    class="text-center mt-5"
                    v-if="!certificate && userData().show_user_on_print == 1"
                  >
                    <hr class="border-black m-0" />
                    Gerado por
                    {{
                      professionalClassCouncilValue({
                        id: user.professional_class_council_id,
                        name: user.name,
                        profile: user.profile_name,
                        cpf: user.cpf,
                        office: user.office,
                        value: user.professional_class_council_value,
                      })
                    }}
                    <small>
                      - {{ moment().format("DD/MM/YYYY HH:mm:ss") }}
                    </small>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="!certificate"
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end content-btn-print"
      >
        <v-btn class="btn-print" @click="print"
          ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
        >
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ResidentDataPrintDefault from "../../../components/resident/ResidentDataPrintDefault";

import History from "../../../templates/History/Prescription";

import { userData } from "../../../lib/functions";

import { formatDate, professionalClassCouncilValue } from "../../../lib/format";

import { getAge } from "../../../lib/getAgeByDate";

import api from "../../../services/api";

import routes from "../../../routes";

import moment from "moment";

import { showUserOnPrint } from "../../../lib/show-user-on-print";

export default {
  name: "PrescriptionPrintCare",

  components: {
    ResidentDataPrintDefault,
    History,
  },

  data() {
    return {
      id: "",

      user: {},

      group_prescription_care: {},

      rest_home_name: "",

      rest_home_fantasy_name: "",

      rest_home_logo_url: null,

      logo: null,

      loading: false,

      certificate: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    getAge,
    moment,
    userData,
    formatDate,
    professionalClassCouncilValue,

    handleFrequency(frequency) {
      let frequencys = {
        DIARIO: "DIÁRIO",
        SEMANAL: "SEMANAL",
        MENSAL: "MENSAL",
        ANUAL: "ANUAL",
        EVENTUAL: "EVENTUAL",
        default: "NÃO ENCONTRADO!!!",
      };

      return frequencys[frequency] || frequencys.default;
    },

    handleEvery(every, frequency) {
      let frequencys = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      return `A CADA ${every} ${frequencys[frequency]}`;
    },

    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },

    async retrieve() {
      let { user, logo } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      let { show_user_on_print } = userData();
      if (show_user_on_print != 1) {
        await showUserOnPrint({
          about: "Prescrição de cuidados",
        });
      }

      let { id } = routes.history.current.params;

      const { certificate } = routes.history.current.query;

      this.id = id;

      if (certificate) {
        this.certificate = certificate;
      }

      await this.get();
    },

    async get() {
      try {
        this.loading = true;

        const { id } = this;

        var params = {
          id,
        };

        const response = await api.get(
          "/rest-home/group-prescription-care/print",
          {
            params,
          }
        );

        const { error, errors, group_prescription_care } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.group_prescription_care = group_prescription_care;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    print() {
      window.print();
    },
  },
};
</script>

<style>
.prescription-care-print .header,
.prescription-care-print .header-space {
  height: auto;
}

.prescription-care-print .header {
  position: fixed;
  top: 0;
}

.prescription-care-print table {
  width: 100% !important;
  cursor: auto !important;
}

.prescription-care-print .logo {
  height: 50px;
  object-fit: contain;
}
.prescription-care-print .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.prescription-care-print .resident_photo_url {
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}
.prescription-care-print .care .capsule {
  width: 20px;
}

.prescription-care-print .care .name {
  margin-left: 10px;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
}
.prescription-care-print .care .frequency {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: flex-end;
}
.prescription-care-print .care .frequency strong {
  font-size: 18px;
}
.prescription-care-print li {
  list-style-type: none;
}
@media print {
  .prescription-care-print button {
    display: none !important;
  }
  .prescription-care-print li {
    list-style-type: none !important;
  }
  .prescription-care-print .finish_user {
    font-size: small !important;
  }
  .prescription-care-print .content-btn-print {
    display: none !important;
  }
}
</style>
